;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:zestlife-web":true});}catch(e){}}();import { warningMessageVar, SnackbarMessageState } from "../../reactiveVars"

type WarningMessageInput = string | SnackbarMessageState | null

export default function updateWarningMessage(
  warningMessage: WarningMessageInput,
): void {
  if (typeof warningMessage === "string") {
    warningMessageVar({
      message: warningMessage,
      duration: 3000,
    })
    return
  }

  if (warningMessage === null) {
    warningMessageVar(warningMessage)
    return
  }

  if (warningMessage.message && warningMessage.duration) {
    warningMessageVar(warningMessage)
    return
  }

  throw new Error("Invalid warningMessage format")
}
